import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-circle-up-large.tsx
/**
* icon.24.circle-up.large
*
* Keywords: arrow, upward, navigation, direction, pointer, ascending, vertical, upload
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMjAgMTJhOCA4IDAgMSAxLTE2IDAgOCA4IDAgMCAxIDE2IDBtMSAwYTkgOSAwIDEgMS0xOCAwIDkgOSAwIDAgMSAxOCAwbS01LjE0Ni0uMzU0LTMuNS0zLjVhLjUuNSAwIDAgMC0uNzA4IDBsLTMuNSAzLjVhLjUuNSAwIDAgMCAuNzA4LjcwOEwxMS41IDkuNzA3VjE1LjVhLjUuNSAwIDAgMCAxIDBWOS43MDdsMi42NDYgMi42NDdhLjUuNSAwIDAgMCAuNzA4LS43MDgiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=875-5569
*/
const Icon24CircleUpLarge = memo(function Icon24CircleUpLarge(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m1 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-5.146-.354-3.5-3.5a.5.5 0 0 0-.708 0l-3.5 3.5a.5.5 0 0 0 .708.708L11.5 9.707V15.5a.5.5 0 0 0 1 0V9.707l2.646 2.647a.5.5 0 0 0 .708-.708",
			clipRule: "evenodd"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M19 11.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m1 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m-5.146-.354-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 0 0 .708.708L11 9.707V14.5a.5.5 0 0 0 1 0V9.707l2.146 2.147a.5.5 0 0 0 .708-.708",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24CircleUpLarge };

//# sourceMappingURL=icon-24-circle-up-large.js.map